// @flow

import { getGateway } from '@tectonics/prs/gateway';
import { type PendingIncomingPayment } from './types';

export function getNequiQRCodeValue(incomingPayment: PendingIncomingPayment): string {
  if (ENV_CONSTANTS.ENV !== 'production') {
    return 'SAMPLE_VALUE_FOR_NON_PRODUCTION';
  }
  
  const gateway = getGateway(incomingPayment);
  return gateway['nequi_qr_code'];
}

export function getNequiExpirationDatetime(incomingPayment: PendingIncomingPayment): string {
  if (ENV_CONSTANTS.ENV !== 'production') {
    return getSampleDatetime();
  }
  
  const gateway = getGateway(incomingPayment);
  return gateway['acquirer_expiration_datetime'];
}

function getSampleDatetime(): string {
  const dateMatches = (new Date()).toISOString().match(/(\d+-\d+-\d+).(\d+:\d+:\d+)/);
  
  if (!dateMatches) {
    throw new Error('Failed to generate a sample datetime');
  }

  return `${dateMatches[1]} ${dateMatches[2]}`;
}
